// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  margin-bottom: ${(props) =>
    props?.isLoginV2FlowEnabled
      ? props.theme.spacing.LAYOUT_SPACING.XXS
      : props.theme.spacing.LAYOUT_SPACING.SM};

  .email-signUp-subHeading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  .email-checkbox-list {
    display: flex;
    flex: 1;
    margin-left: -10px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: inline-flex;
    }
  }

  .email-signup-tcp {
    flex: 1;
  }

  .email-signup-gym {
    flex: 1;
    @media ${(props) => props.theme.mediaQuery.medium} {
      flex: 2;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      flex: 3;
    }
  }

  .email-signup-text {
    margin-top: ${(props) =>
      props?.isLoginV2FlowEnabled ? props.theme.spacing.ELEM_SPACING.LRG : '0px'};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    @media ${(props) => props.theme.mediaQuery.large} {
      max-width: 50%;
    }
  }

  .email-signup-disclaimer_txt {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
  }
  .image {
    height: 35px;
    width: 55px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .snj-logo {
      height: 25px;
      margin-top: 5px;
    }
  }
  .signupcheckbox-header {
    text-transform: capitalize;
  }
  .checkbox .CheckBox__input {
    width: 18px;
    height: 18px;
    margin-left: 15px;
    margin-top: 2px;
    border-radius: 2px;
  }
  .checkbox .CheckBox__input:before {
    border: 2px solid #9b9b9b;
    border-radius: 4px;
    width: 18px;
    height: 18px;
    margin-left: -2px;
    margin-top: -2px;
  }
  .CheckBox__input:checked:after {
    left: 8px;
    top: 2px;
  }
  .labelStyle {
    margin-top: -6px;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .checkBoxLabelAlign {
      min-width: max-content;
    }
  }
`;

export default styles;
